<form class="modal-form" [formGroup]="form" (submit)="submit()">
  <p class="subscriber-freight-note" *ngIf="subscriberFreightNote">
    {{ subscriberFreightNote }}
  </p>

  <span class="p-float-label">
    <p-dropdown
      inputId="addressType"
      formControlName="addressType"
      [options]="addressTypeOptions"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      [autoDisplayFirst]="false"
    />
    <label for="addressType">Tipo *</label>
    <small class="error" *ngIf="invalidControl('addressType')"
      >Campo obrigatório</small
    >
  </span>

  <span class="p-float-label">
    <p-inputMask
      inputId="postalCode"
      formControlName="postalCode"
      mask="99999-999"
      placeholder="99999-999"
      (onComplete)="onPostalCodeComplete()"
    />
    <label for="postalCode">CEP *</label>
    <small
      class="error"
      *ngIf="
        invalidControl('postalCode') &&
        form.controls.postalCode.hasError('required')
      "
      >Campo obrigatório</small
    >
    <small
      class="error"
      *ngIf="
        invalidControl('postalCode') &&
        form.controls.postalCode.hasError('postalCode')
      "
      >{{ invalidCepMessage }}</small
    >
    <small class="warning" *ngIf="cepLookupMessage">{{
      cepLookupMessage
    }}</small>
  </span>

  <span class="p-float-label">
    <input id="street" type="text" pInputText formControlName="street" />
    <label for="street">Logradouro *</label>
    <small class="error" *ngIf="invalidControl('street')"
      >Campo obrigatório</small
    >
  </span>

  <span class="p-float-label">
    <input
      id="streetNumber"
      type="text"
      pInputText
      formControlName="streetNumber"
    />
    <label for="streetNumber">Número *</label>
    <small class="error" *ngIf="invalidControl('streetNumber')"
      >Campo obrigatório</small
    >
  </span>

  <span class="p-float-label">
    <input
      id="streetExtension"
      type="text"
      pInputText
      formControlName="streetExtension"
    />
    <label for="streetExtension">Complemento</label>
  </span>

  <span class="p-float-label">
    <input
      id="neighborhood"
      type="text"
      pInputText
      formControlName="neighborhood"
    />
    <label for="neighborhood">Bairro *</label>
    <small class="error" *ngIf="invalidControl('neighborhood')"
      >Campo obrigatório</small
    >
  </span>

  <span class="p-float-label">
    <input id="city" type="text" pInputText formControlName="city" />
    <label for="city">Cidade *</label>
    <small class="error" *ngIf="invalidControl('city')"
      >Campo obrigatório</small
    >
  </span>

  <span class="p-float-label">
    <input id="state" type="text" pInputText formControlName="state" />
    <label for="state">Estado *</label>
    <small class="error" *ngIf="invalidControl('state')"
      >Campo obrigatório</small
    >
  </span>

  <span class="p-float-label">
    <input id="country" type="text" pInputText formControlName="country" />
    <label for="country">País</label>
  </span>

  <span class="p-float-label">
    <input
      id="recipientName"
      type="text"
      pInputText
      formControlName="recipientName"
    />
    <label for="recipientName">Destinatário</label>
  </span>

  <span class="p-float-label">
    <input id="phone" type="text" pInputText formControlName="phone" />
    <label for="phone">Telefone</label>
  </span>

  <div class="buttons">
    <p-button
      label="Cancelar"
      severity="secondary"
      [outlined]="true"
      type="button"
      (onClick)="ref.close()"
    />
    <p-button label="Salvar" type="submit" />
  </div>
</form>
